<!--
 * @Author: DY
 * @Date: 2023-08-02 16:15:40
 * @LastEditTime: 2023-09-04 13:55:36
 * @Description: 隐私政策
 * @FilePath: \ShiMo_Mobile\src\views\public\privacyPolicy.vue
-->
<template>
    <v-touch @swiperight="swiperright">
        <div class="privacyPolicy">
            <h1 class="title">
                隐私政策
            </h1>
            <p>生效日期：2025年01月01日</p>
            <p>
                “数智石墨”尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更安全的服务，“数智石墨”会按照本隐私权政策的规定使用和披露
                您的个人信息。但“数智石墨”将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下， “数智石墨”不会将这些信息对外披露或向第三方提供。“数智石墨”会不时更新本隐私权政策。
                您在同意“数智石墨”服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于“数智石墨”服务使用协议不可分割的一部分。
            </p>

            <h1>1. 适用范围</h1>
            <p>a) “数智石墨”帐号注册是在ERP系统完成个人信息录入；</p>
            <p>
                b)
                在您使用“数智石墨”网络服务，或访问“数智石墨”平台网页时，“数智石墨”自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、MAC地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
            </p>
            <p>c) “数智石墨”通过合法途径从商业伙伴处取得的用户个人数据。</p>
            <p>您了解并同意，以下信息不适用本隐私权政策：</p>
            <div>
                <p>a) 您在使用”数智石墨”平台提供的搜索服务时输入的关键字信息；</p>
                <p>b) 当您使用“数智石墨”即时通讯功能时，我们会获取您的摄像头、录音、文字读写权限以保证完整的即时通讯功能实现</p>
                <p>c) 当您使用拍照并上传的相应功能时，我们会在应用中获取您的照片存储权限及信息</p>
                <p>d) 当您使用“数智石墨”地图功能时，我们会获取您的位置信息</p>
                <p>e) ”数智石墨”收集到的您在”数智石墨”发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>
                <p>f) 违反法律规定或违反”数智石墨”规则行为及”数智石墨”已对您采取的措施</p>
            </div>
            <p>d）为了在不同手机设备上使用相应功能，我们接入了第三方SDK我们已将这些具有个人信息收集功能的第三方SDK的名称、所提供的功能/服务、官网链接、隐私政策链接、申请调用的权限及收集个人信息类型展示如下</p>
            <div>
                <h2>推送服务</h2>
                <dl>
                    <dt>第三方 SDK 名称:华为推送SDK（Android版）</dt>
                    <dt>第三方公司名称:华为软件技术有限公司</dt>
                    <dd>使用目的:用于消息推送</dd>
                    <dd>收集的个人信息类型:应用信息、设备信息（设备的硬件信息、系统基本信息和系统设置）</dd>
                    <dd>
                        第三方隐私政策链接:https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177
                    </dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:小米推送SDK</dt>
                    <dt>第三方公司名称:北京小米移动软件有限公司</dt>
                    <dd>使用目的:用于向您推送消息</dd>
                    <dd>收集的个人信息类型:设备标识(OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置</dd>
                    <dd>第三方隐私政策链接:https://dev.mi.com/distribute/doc/details?pId=1534</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:vivo推送SDK</dt>
                    <dt>第三方公司名称:维沃移动通信有限公司</dt>
                    <dd>使用目的:提供推送消息服务、统计推送SDK接口调用成功率。</dd>
                    <dd>收集的个人信息类型:应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息。</dd>
                    <dd>第三方隐私政策链接:https://dev.vivo.com.cn/documentCenter/doc/652</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:OPUSH SDK</dt>
                    <dt>第三方公司名称:广东欢太科技有限公司</dt>
                    <dd>使用目的:消息推送服务</dd>
                    <dd>收集的个人信息类型:应用基本信息（MCS应用包名、应用版本号、OPUSH SDK版本号），应用内设备标识符（RegistraterID、appKey、appSecret）。</dd>
                    <dd>第三方隐私政策链接:https://open.oppomobile.com/new/developmentDoc/info?id=11228</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:魅族推送SDK</dt>
                    <dt>第三方公司名称:珠海星纪魅族信息技术有限公司</dt>
                    <dd>使用目的:推送消息</dd>
                    <dd>收集的个人信息类型:设备相关信息（手机品牌、手机型号、系统版本、系统语言，以及设备标识符 PUSHID）和应用信息、推送状态</dd>
                    <dd>第三方隐私政策链接:https://open.flyme.cn/docs?id=202</dd>
                </dl>
            </div>
            <div>
                <h2>位置服务</h2>
                <dl>
                    <dt>第三方 SDK 名称:百度地图SDK</dt>
                    <dt>第三方公司名称:北京百度网讯科技有限公司</dt>
                    <dd>使用目的:为最终用户提供地图展示和搜索、步骑行导航功能及服务</dd>
                    <dd>
                        收集的个人信息类型:设备信息（包括Android
                        ID、IDFV、操作系统版本、设备品牌及型号、设备配置、应用信息（应用名）、陀螺仪角度）、位置信息【可能包括经纬度、设备信号强度信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、位置信息（可能包括GNSS信息、WiFi地址及信号强度信息、基站ID数据信息、传感器信息、设备信号强度信息、IP地址和蓝牙信息）、网络状态（如移动网络、WiFi网络或无网状态）、图像信息
                    </dd>
                    <dd>第三方隐私政策链接:https://lbs.baidu.com/index.php?title=openprivacy</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:百度定位SDK</dt>
                    <dt>第三方公司名称:北京百度网讯科技有限公司</dt>
                    <dd>使用目的:为最终用户提供定位功能及服务</dd>
                    <dd>
                        收集的个人信息类型:设备信息【包括设备标识信息（Android
                        ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）】、位置信息【可能包括经纬度、GNSS信息、WiFi网关地址、WiFi
                        MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、网络类型【如移动网络、WiFi网络】
                    </dd>
                    <dd>第三方隐私政策链接:https://lbs.baidu.com/index.php?title=openprivacy</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:百度导航SDK</dt>
                    <dt>第三方公司名称:北京百度网讯科技有限公司</dt>
                    <dd>使用目的:为最终用户提供导航功能及服务</dd>
                    <dd>
                        收集的个人信息类型:设备信息（包括Android
                        ID、IDFV、操作系统版本、设备品牌及型号、设备配置、应用信息（应用名））、位置信息（可能包括GNSS信息、WiFi地址及信号强度信息、基站ID数据信息、传感器信息、设备信号强度信息、IP地址和蓝牙信息）、网络状态（如移动网络、WiFi网络或无网状态）、出发地、到达地、图像信息。
                    </dd>
                    <dd>第三方隐私政策链接:https://lbs.baidu.com/index.php?title=openprivacy</dd>
                </dl>
            </div>
            <div>
                <h2>环信即时通讯</h2>
                <dl>
                    <dt>第三方 SDK 名称:环信IM、Hyphenate-chat SDK</dt>
                    <dt>第三方公司名称:北京亿思摩博网络科技有限公司</dt>
                    <dd>收集的个人信息类型:用户ID、APPID（应用包名）、设备随机ID、设备硬件类型、设备型号、系统类型、SDK版本、设备网络类型、登录用时</dd>
                    <dd>使用目的:提供消息投递、多端消息同步、消息漫游功能，同时为了预防安全风险，准确识别违反法律法规的情况</dd>
                    <dd>使用场景:单聊、群聊</dd>
                    <dd>第三方隐私链接:https://www.easemob.com/protocol</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:视频 SDK</dt>
                    <dt>第三方公司名称:上海兆言网络科技有限公司</dt>
                    <dd>
                        收集的个人信息类型:设备品牌、设备型号、操作系统版本、CPU信息、内存使用情况、电池电量信息、屏幕分辨率、IP地址、网络接入方式和类、频道内用户ID（在同一频道内标识用户的非重复的数字或字符串ID）、传感器信息（设备的屏幕旋转方向）
                    </dd>
                    <dd>使用目的:视频通话</dd>
                    <dd>第三方隐私链接:https://www.shengwang.cn/SDK-privacy-policy/</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:音频 SDK</dt>
                    <dt>第三方公司名称:上海兆言网络科技有限公司</dt>
                    <dd>
                        收集的个人信息类型:设备品牌、设备型号、操作系统版本、CPU信息、内存使用情况、电池电量信息、屏幕分辨率、IP地址、网络接入方式和类、频道内用户ID（在同一频道内标识用户的非重复的数字或字符串ID）、传感器信息（设备的屏幕旋转方向）
                    </dd>
                    <dd>使用目的:音频通话</dd>
                    <dd>第三方隐私链接:https://www.shengwang.cn/SDK-privacy-policy/</dd>
                </dl>
            </div>
            <div>
                <h2>云信即时通讯</h2>
                <dl>
                    <dt>第三方 SDK 名称:网易云信 IM 即时通讯、IM_Android</dt>
                    <dt>第三方公司名称:杭州网易质云科技有限公司</dt>
                    <dd>共享类型:内嵌SDK</dd>
                    <dd>
                        收集的个人信息类型:唯一设备识别码（APNS
                        Token、设备序列号、AndroidID、OAID、GAID、IDFV、CID、MAC地址）；设备运行状态（SIM卡状态、USB状态、充电状态、电池容量及电量、锁屏时间、启动时间）；设备信息（设备类型、设备品牌及型号、设备厂商、设备所运行系统版本、名称、编辑版本信息、系统内核信息、CPU型号、设备内存及存储大小、屏幕亮度及分辨率、设备输入装置、设备架构、基带信息、字体HASH、HOSTNAME、辅助功能列表、系统进程列表）；日志信息（设备运行状态（CPU、内存运行状态）、浏览器类型及版本信息、网络连接类型及状态、WIFISSID、WIFIBSSID、IP地址、运营商信息、网络代理、云信通信服务运行日志信息）。
                    </dd>
                    <dd>获取的权限:摄像头、麦克风、访问网络权限、网络连接状态、Wifi网络状态、存储读写、地理位置、呼吸灯、振动器</dd>
                    <dd>使用目的:提供消息投递、多端消息同步、消息漫游功能，同时为了预防安全风险，准确识别违反法律法规的情况</dd>
                    <dd>使用场景:用户私聊、群聊、聊天室等</dd>
                    <dd>共享方式:（外部）接口共享</dd>
                    <dd>第三方隐私链接:https://yunxin.163.com/clauses?serviceType=3</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:网易云信 RTC 音视频通话</dt>
                    <dt>第三方公司名称:杭州网易质云科技有限公司</dt>
                    <dd>共享类型:内嵌SDK</dd>
                    <dd>
                        收集的个人信息类型:设备信息，包含设备类型、设备名称及型号、设备所运行系统版本信息、AndroidID；日志信息，包含设备运行状态（CPU、内存运行状态）、浏览器类型及版本、IP地址、通话状态；陀螺仪、距离传感器信息、加速器传感器信息。
                    </dd>
                    <dd>获取的权限:摄像头、麦克风、访问网络权限、网络连接状态、Wifi网络状态、存储读写、蓝牙、电话状态权限、修改音频设置</dd>
                    <dd>使用目的:提供实时音视频通话服务，保障云信音视频服务的运行安全和服务体验，了解产品适配度，以便对音视频服务质量进行适配调优，同时为了预防安全风险，准确识别违反法律法规的情况。</dd>
                    <dd>使用场景:音视频通话等</dd>
                    <dd>共享方式:（外部）接口共享</dd>
                    <dd>第三方隐私政策链接:https://yunxin.163.com/clauses?serviceType=3</dd>
                </dl>
            </div>
            <div>
                <h2>其他</h2>
                <dl>
                    <dt>第三方 SDK 名称:腾讯浏览服务X5网页引擎SDK（Android）</dt>
                    <dd>第三方公司名称:深圳市腾讯计算机系统有限公司</dd>
                    <dd>使用目的:为用户提供访问web应用的功能</dd>
                    <dd>
                        收集的个人信息类型:设备信息（设备型号、操作系统、CPU类型）、应用信息（宿主应用包名，版本号）、Wi-Fi状态和参数（不包含wifi
                        mac）、IP地址、AndroidID、精确位置信息（可选）、附近的Wi-Fi（可选）、CellID（可选）、OAID（可选）、BSSID（可选）、SSID（可选）
                    </dd>
                    <dd>第三方隐私链接:https://rule.tencent.com/rule/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d</dd>
                </dl>
                <dl>
                    <dt>第三方 SDK 名称:Bugly漏洞标记SDK</dt>
                    <dd>第三方公司名称:深圳市腾讯计算机系统有限公司</dd>
                    <dd>使用目的:记录用户操作日志，崩溃信息</dd>
                    <dd>收集的个人信息类型:设备信息（IMSI、IMSI、设备 MAC 地址、SUPI、SUCI、ANDROID ID、硬件序列号/DEVICEID）、软件安装列表、网络信息、位置信息</dd>
                    <dd>第三方隐私链接:https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</dd>
                </dl>
            </div>

            <h1>2. 我们如何收集和使用您的个人信息</h1>
            <p>a) 账号登录</p>
            <div>
                <p>当您登录时，如您使用一键登录的功能，基于我们与通信运营商的合作，我们会收集您的【手机号码和手机运营商信息】。</p>
                <p>基于我们与通信运营商的合作，我们会收集您手机设备上的IMEI相关信息。</p>
            </div>
            <p>b) 账号注销</p>
            <div>
                <p>"数智石墨"为企业内部ERP系统，在员工离职后统一由系统管理员在后台系统进行维护。</p>
                <p>在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。您将无法再次使用该账号登录数智石墨等，也无法找回该账号下的个人信息、业务数据、历史信息等</p>
            </div>
            <p>c) 互动功能与服务</p>
            <div>
                <p> a）当您关注您感兴趣的账号、进行浏览、评论、点赞、收藏、分享内容时，我们会收集您关注的账号和前述信息。</p>
                <p> b）当您使用通讯录好友功能时，在获得您明示同意后，我们会收集您的通讯录信息。</p>
                <p> c）当您选择使用扫码添加好友时，我们可能会向您请求摄像头权限。</p>
            </div>

            <p>d) 安全运行与风控验证</p>
            <div>
                <p>
                    为了保障软件与服务的安全运行，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们会主动收集您的设备信息【包括:设备/硬件型号、设备名称、SIM卡序列号(如ICCID)、设备/硬件序列号(SN)、设备唯一标识符(包括:IME1、IMSl、Android
                    ID、IDFA、IDFV、OAID、MEID)】、运行中的进程、存储(相册、媒体和其他文件)、浏览器类型和设置、语言设置、传感器、操作系统、操作系统版本号和应用程序版本、应用列表、网络设备硬件地址(MAC地址)、WLANMAC、WLAN接入点(如SSID，BSSID)、IP地址、蓝牙地址、接入网络的方式、网络质量数据、基站、移动网络信息(包括运营商名称)、设备传感器数据(如加速度传感器、线性加速度传感器、重力传感器、陀螺仪传感器)、软件版本号以及软件使用记录信息上传到服务器处理，用于安全风控验证。如您不同意我们收集前述信息，可能无法完成风控验证，请您理解。
                </p>
            </div>

            <h1>3. 信息使用</h1>
            <p>
                a)
                “数智石墨”不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和“数智石墨”（含“数智石墨”关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
            </p>
            <p>b) “数智石墨”亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何“数智石墨”平台用户如从事上述活动，一经发现，“数智石墨”有权立即终止与该用户的服务协议。</p>
            <p>
                c)
                为服务用户的目的，“数智石墨”可能通过使用您的个人信息，向您提供您涉及到业务数据提醒，包括但不限于向您发出待办和通知信息，或者与“数智石墨”合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。
            </p>

            <h1>4. 信息披露</h1>
            <p>a) 经您事先同意，向第三方披露；</p>
            <p>b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
            <p>c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
            <p>d) 如您出现违反中国有关法律、法规或者“数智石墨”服务协议或相关规则的情况，需要向第三方披露；</p>
            <p>e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
            <p>f) 在“数智石墨”平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，“数智石墨”有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
            <p>g) 其它“数智石墨”根据法律、法规或者网站政策认为合适的披露。</p>

            <h1>5. 信息存储和交换</h1>
            <p>“数智石墨”收集的有关您的信息和资料将保存在“数智石墨”及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或“数智石墨”收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>

            <h1>6. Cookie的使用</h1>
            <p>
                a)
                在您未拒绝接受cookies的情况下，“数智石墨”会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的“数智石墨”平台服务或功能。“数智石墨”使用cookies可为您提供更加周到的使用服务，包括通知服务。
            </p>
            <p>
                b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的“数智石墨”网络服务或功能。
            </p>
            <p>c) 通过“数智石墨”所设cookies所取得的有关信息，将适用本政策。</p>

            <h1>7. 信息安全 </h1>
            <p>
                a)
                “数智石墨”帐号均有安全保护功能，请妥善保管您的用户名及密码信息。“数智石墨”将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。
            </p>
            <p>
                b) 在使用“数智石墨”网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。
                请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是“数智石墨”用户名及密码发生泄露，请您立即联络“数智石墨”客服，以便“数智石墨”采取相应措施。
            </p>

            <h1>8. 未成年人信息处理</h1>
            <p>a) 任何18岁以下的未成年人均不得创建自己的用户账户及使用我们的服务。</p>
            <p>b) 我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所需的必要的情况下使用或披露未成年人的个人信息</p>

            <h1>9. 如何储存您的个人信息</h1>
            <p>a) 我们在中华人民共和国境内运营中收集和产生的您的个人信息，存储在中国境内。</p>
            <p>一般而言，我们自您使用服务时获取到您个人信息之日起至您注销账户后6个月内会存储并保留您的个人信息。</p>
            <p>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
            <p>当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>

            <h1>10. 自启动和关联启动说明 </h1>
            <p>a) 为确保本应用处于关闭或者后台运行状态下可以正常接收客户端推送的广播消息，本应用须使用（自启动）能力，将存在一定频率通过系统发送广播唤醒本应用自启动行为，是因实现功能及服务所必要的。 </p>

            <h1>11. 本隐私政策如何更新</h1>
            <p>我们的隐私权政策可能变更。</p>
            <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过公示的方式进行通知甚至向您提供弹窗提示）。</p>
            <h1>本政策所指的重大变更包括但不限于：</h1>
            <div>
                <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
                <p>2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；</p>
                <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
                <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
                <p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
                <p>6、个人信息安全影响评估报告表明存在高风险时。</p>

                <p>我们还会将本隐私权政策的旧版本存档，供您查阅。</p>
            </div>

            <h1>12. 如何联系我们</h1>
            <p>
                如您对个人信息保护问题有任何投诉、建议、疑问，或您对本政策有任何疑问，您可以通过以下方式联系我们，我们将尽快审核所涉及问题，并在验证您的用户身份后的十五个工作日内答复。联系方式：bjjykjyxgs@126.com
            </p>

            <h1>关于我们</h1>
            <p>数智石墨的PC端平台及APP的经营者为中建材石墨新材料有限公司。</p>
            <p>注册地址为：北京市北京市海淀区复兴路17号国海广场B座17层</p>
        </div>
    </v-touch>
</template>

<script>
export default {
    name: 'privacy-policy',
    components: {},
    data() {
        return {};
    },
    watch: {},
    created() {},
    mounted() {},
    computed: {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.privacyPolicy
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 20px;
    .title
        text-align: center
        font-size: 24rpx;
        margin-bottom 20rpx
        font-weight: 600
    p
        text-indent: 2em;
    h1:not(.title),h2
        font-size: 20rpx;
        font-weight: 800;
        margin: 20rpx 0;
    dl
        margin: 0;
    div
        padding-left: 2em;
    p,dt,dd
        font-size: 16rpx;
</style>
